export function updateNotice(notices = [], noticeId, data = {}) {
  const newNotices = [...notices];
  const targetIndexTest = newNotices.findIndex((item) => item.id === noticeId);

  if (targetIndexTest < 0) {
    newNotices.push({
      id: noticeId,
    });
  }

  const targetIndex = newNotices.findIndex((item) => item.id === noticeId);

  if (targetIndex < 0) {
    return newNotices;
  }

  newNotices[targetIndex] = {
    ...newNotices[targetIndex],
    ...data,
  };

  return newNotices;
}
